import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Navigate } from 'react-router-dom';
import { ShieldCheck } from 'lucide-react';
import api from '@/lib/api';
import SuperAdminSection from '@/components/SuperAdminSection';

/** /vyndesk-admin — yalnız süper-admin yetkili desk'te (backend enabled), aksi halde dashboard'a. */
export default function VyndeskAdmin() {
  const { t } = useTranslation('admin');
  const [enabled, setEnabled] = useState<boolean | null>(null);
  useEffect(() => {
    api.get('/superadmin/status').then(r => setEnabled(Boolean(r.data?.data?.enabled))).catch(() => setEnabled(false));
  }, []);
  if (enabled === null) return <div className="p-8 text-sm text-slate-400">…</div>;
  if (!enabled) return <Navigate to="/dashboard" replace />;
  return (
    <div className="mx-auto max-w-7xl p-4 md:p-6">
      <div className="mb-4 flex items-center gap-3">
        <div className="flex h-10 w-10 items-center justify-center rounded-xl bg-violet-100 text-violet-700"><ShieldCheck className="h-5 w-5" /></div>
        <div>
          <h1 className="text-lg font-bold text-slate-900">{t('page.title')}</h1>
          <p className="text-xs text-slate-500">{t('page.description')}</p>
        </div>
      </div>
      <SuperAdminSection />
    </div>
  );
}
